import { render, staticRenderFns } from "./OverlayComponent.vue?vue&type=template&id=4577c01c&"
import script from "./OverlayComponent.vue?vue&type=script&lang=js&"
export * from "./OverlayComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports